var generic = window?.generic || {};

(function ($, site) {
  Drupal.behaviors.skinFinderResultsV1 = {
    attached: false,
    nodes: {},
    translations: {},
    backOrderEnabled: Drupal.settings.elc_ecom.prodcatConfig.backorder.enabled,
    notifyMeEnabled: Drupal.settings.elc_ecom.prodcatConfig?.waitlist?.enabled,
    notifyMeEnabledByStatus: Drupal.settings.elc_ecom.prodcatConfig?.waitlist?.enabledByStatus,
    modernizedTheme: false,
    sizesToShow: 2,
    shadesToShow: 5,
    sizesMaxLength: 12,
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.getTheme();
      self.getDom(context);
      self.getTranslations();
      self.setEvents(context);
    },

    selectors: {
      wrapper: '.js-mantle-finder',
      quizFormatter: '.js-quiz-page-formatter',
      carousel: '.js-product-brief-carousel-items',
      formItem: '.js-form-formatter__item',
      contentApiWrapper: '.js-content-api-wrapper'
    },

    getTheme: function () {
      var self = this;
      var resultTemplate = $('script.inline-template[path="templates/mantle/results/partial_template"]').html();

      if (resultTemplate && resultTemplate.indexOf('js-modernized-theme') !== -1) {
        self.modernizedTheme = true;
      }
    },

    getDom: function (context) {
      var self = this;

      self.nodes.$wrapper = $(self.selectors.wrapper, $(context));
      self.nodes.$quizFormatter = $(self.selectors.quizFormatter, self.nodes.$wrapper);
      self.nodes.formItem = self.nodes.$quizFormatter.find(self.selectors.formItem);
      self.nodes.$contentApiWrapper = $(self.selectors.contentApiWrapper, self.nodes.$wrapper);
    },

    getTranslations: function () {
      var self = this;
      var product = site.translations?.product || {};
      var elcProduct = site.translations?.elc_product || {};
      var elcCart = site.translations?.elc_cart || {};
      var elcGeneral = site.translations?.elc_general || {};
      var formName = self.nodes.$quizFormatter.data('formName');

      self.translations = window.__quiz_translations__[formName] || {};
      if (self.modernizedTheme) {
        self.translations.add_to_bag = product.add_to_bag || elcCart.add_to_bag || 'Add to bag';
        self.translations.coming_soon = product.coming_soon || elcProduct.coming_soon || 'Coming soon';
        self.translations.coming_soon_msg = product.coming_soon_stock_msg || elcProduct.item_is_coming_soon_notify_me || 'This shade/size: Coming Soon';
        self.translations.sold_out = product.sold_out || elcProduct.sold_out || 'Sold Out';
        self.translations.item_is_sold_out = product.item_is_sold_out || elcProduct.item_is_sold_out || 'Item is Sold Out';
        self.translations.temp_out_of_stock = product.temp_out_of_stock || elcProduct.temp_out_of_stock || 'Add To Bag';
        self.translations.notify_me = site.translations.elc_communications.notify_me || 'Notify Me';
        self.translations.item_is_temp_out_of_stock = product.item_is_temp_out_of_stock || elcProduct.item_is_temp_out_of_stock || 'In stock soon';
        self.translations.loading = elcGeneral.loading || 'Loading';
      }
    },

    setEvents: function (context) {
      var self = this;
      var $submitBtn;

      if (self.modernizedTheme) {
        // Set loading text on form submit
        self.nodes.$quizFormatter.on('mantle-form:submit-requested', function () {
          $submitBtn = self.nodes.$quizFormatter.find('.js-mantle-cta-button[data-trigger-type="submit"]');
          self.submitText = self?.submitText
            || self.nodes.$quizFormatter.find('.js-mantle-cta-button[data-trigger-type="submit"]').first().text().trim()
            || 'See results';
          $submitBtn.addClass('submit-loading').text(self.translations.loading);
        });

        // Reset CTA text on form reset
        self.nodes.$quizFormatter.on('click', '.js-mantle-form-reset', function () {
          self.nodes.$quizFormatter.find('.js-mantle-cta-button[data-trigger-type="submit"]').removeClass('submit-loading').text(self?.submitText);
        });
      }

      self.nodes.$quizFormatter.on(
        'mantle-form:request-form-results--perlgem',
        function (e, response) {
          var result_promise = self.parseApiResponse(response);

          result_promise.then(function (result_html) {
            var $activeItem = $('.js-form-formatter__item').filter('.active');

            $activeItem.removeClass('active');
            self.nodes.$quizFormatter.trigger('mantle-quiz-render-results--partial', [
              $(result_html)
            ]);
            self.appendNodeContent();

            var isMobile =
              parseInt(Unison.fetch.now().width) === parseInt(Unison.fetch.all().small);

            if (self.modernizedTheme) {
              self.setModernizedCarousel();
              self.generateCarousel();
              self.setAtbListener();
              self.equalizeTitleHeights();
            } else if (!isMobile) {
              self.setCarousel();
              self.qsInit(context);
            }

            // On screen size change
            Unison.on('change', function () {
              isMobile = parseInt(Unison.fetch.now().width) === parseInt(Unison.fetch.all().small);

              if (self.modernizedTheme) {
                self.setModernizedCarousel();
                self.equalizeTitleHeights();
              } else if (!isMobile) {
                self.setCarousel();
                self.qsInit(context);
              }
            });
          });
        }
      );

      self.nodes.$quizFormatter.on('mantle-form:request-tokenless', function () {
        var buid = Drupal.settings.elc_ecom.businessUnitId;
        var token = window.btoa(`${buid}:${origin}`);

        return token;
      });
    },

    removeZeroPriceSkusFromData: function (data) {
        if (data?.products?.length > 0) {
            data.products.forEach((product) => {
                if (product?.skus) {
                    product.skus = product.skus.filter((sku) => sku?.PRICE !== 0);
                }
            });
            data.products = data.products.filter((product) => product?.skus?.length > 0);
        }
    },

    parseApiResponse: function (response) {
      var self = this;
      var deferred = $.Deferred();
      var promise;

      // data has already been processed
      if (!!response && response.results.length > 0 && !!response.results[0].products) {
        var result_html = self.quizResultsHtml(response);

        deferred.resolve(result_html);
      }
      if (!!response && response.results.length > 0 && !!response.results[0].product_id) {
        promise = self.getPerlgemProductData(response.results[0].product_id);

        promise.then(function (result) {
          if (Drupal.settings.skin_finder_results_remove_samples) {
            self.removeSamplesAndRefillsFromData(result);
          }
          self.removeZeroPriceSkusFromData(result);
          self.preprocessProductData(result);
          response.results = self.mergeResultsData(result, response.results[0]);
          var result_html = self.quizResultsHtml(response);

          deferred.resolve(result_html);
        });
      }

      return deferred;
    },

    getPerlgemProductData: function (results) {
      var resultsArr = results.split(',');

      resultsArr.forEach(function (val, i) {
        resultsArr[i] = val.indexOf('PROD') !== -1 ? val : 'PROD' + val;
      });

      var deferred = $.Deferred();
      var queryParams = [
        {
          method: 'prodcat.querykey',
          params: [
            {
              products: resultsArr,
              query_key: 'tout-mpp-product',
              _TOKEN: $.cookie('csrftoken')
            }
          ]
        }
      ];

      $.ajax({
        url: '/rpc/jsonrpc.tmpl',
        type: 'post',
        data: $.param({ JSONRPC: JSON.stringify(queryParams) })
      })
        .done(function (response) {
          if (response.length > 0 && response[0].result) {
            var productsData = response[0].result.value;

            page_data['custom-mpp'] = productsData;
            deferred.resolve(productsData);
          }
        })
        .fail(function (err) {
          deferred.reject(err);
        });

      return deferred.promise();
    },

    mergeResultsData: function (productsData, resultsData) {
      var self = this;
      var results = [];
      var resultsDataObj = {};
      var benefitBaseMap = {};
      var baseCounter = 1;
      var benefitType;

      resultsDataObj['products'] = [];
      if (!!productsData && !!productsData.products && !!resultsData) {
        productsData.products.forEach(function (val, i) {
          if (!!val) {
            var data = {};
            var resResultsObj = self.restructureObjByIndex(resultsData, i);

            $.extend(data, resResultsObj.productData, val);

            if (self.modernizedTheme) {
              benefitType = data?.product_benefit_type;

              if (benefitType) {
                if (!benefitBaseMap[benefitType]) {
                  benefitBaseMap[benefitType] = baseCounter++;
                }
                data.step = benefitBaseMap[benefitType];
              }
            }

            results.push(data);
            if (Object.keys(resultsDataObj).length <= 1) {
              $.extend(resultsDataObj, resResultsObj.resultsData);
            }
          }
        });
      }
      resultsDataObj.products = results;
      results = [];
      results.push(resultsDataObj);

      return results;
    },

    restructureObjByIndex: function (object, index) {
      var self = this;
      // splitting the values that need to be parsed in the mustache file from the ones that don't
      var restructuredObject = {};

      restructuredObject['productData'] = {};
      restructuredObject['resultsData'] = {};
      for (key in object) {
        if (!(object[key] instanceof Array)) {
          object[key] = object[key].split(',');
        }
        if (object[key] instanceof Array && object[key].length > 1) {
          restructuredObject.productData[key] = self.getTranslatedValue(key, object[key][index]);
        } else {
          restructuredObject.resultsData[key] = self.getTranslatedValue(key, object[key]);
        }
      }

      return restructuredObject;
    },

    getTranslatedValue: function (field, value) {
      var self = this;

      if (typeof value !== 'string') {
        return value;
      }
      var tsKey =
        field.toLowerCase().replace(' ', '_') + '_' + value.toLowerCase().replace(' ', '_');

      if (self.translations.hasOwnProperty(tsKey)) {
        value = self.translations[tsKey];
      }

      return value;
    },

    quizResultsHtml: function (results) {
      var self = this;
      var formatterData = self.nodes.$quizFormatter.data();

      results.results.forEach(function (val, i) {
        val.ctaText = val.ctaText || formatterData.resultsCtaText;
        val.ctaLink = val.result_mpp_url || formatterData.resultsCtaLink || '#';
        val.resultsDescription = val.result_description || formatterData.resultsDescription;
      });

      var $tmp = $('script.inline-template[path="templates/mantle/results/partial_template"]');

      html = site.template.render($tmp.html(), results);

      if (self.modernizedTheme) {
        self.nodes.$wrapper.addClass(
          self.backOrderEnabled ? '' : 'backorder-unavailable'
        );
      }

      $(document).trigger('filterResult', { html });

      return html;
    },

    removeSamplesAndRefillsFromData: function (data) {
      if (data?.products?.length > 0) {
        data.products.forEach((product) => {
          if (product?.skus) {
            product.skus = product.skus.filter(
              (sku) => !(sku?.REFILLABLE === 1 || sku?.SKU_TYPE === 'I2')
            );
          }
        });
      }
    },
    preprocessProductData: function (data) {
      var self = this;
      var prod;
      var skus;
      var skuImages;
      var mediumImages;
      var invStatus;

      if (self.modernizedTheme) {
        if (data?.products?.length > 0) {
          data.products.forEach(function (product, i) {
            if (!product) {
              return;
            }

            prod = data.products[i];
            skus = product.skus || [];

            if (skus.length > 0) {
              prod.defaultSku = null;

              skus.forEach(function (sku, j) {
                skuImages = sku.IMAGE_LARGE || sku.LARGE_IMAGE || [];

                prod.skus[j].medium_image = skuImages[0] || '';
                prod.skus[j].alt_medium_image =
                  skuImages[skuImages.length > 1 ? 1 : 0] || '';
                prod.skus[j].inventoryStatus = self.getInventoryStatus(sku);

                if (sku.DEFAULT_SKU) {
                  prod.defaultSku = sku;
                }
              });

              if (!prod.defaultSku) {
                prod.defaultSku = prod.skus[0];
              }
              self.getLabelLength(prod);
            }

            mediumImages = prod?.defaultSku?.IMAGE_LARGE
                    || prod?.defaultSku?.LARGE_IMAGE
                    || ['/media/images/global/image_placeholder.svg'];

            prod.first_medium_image = mediumImages[0] || '';
            prod.first_alt_medium_image = mediumImages[mediumImages.length > 1 ? 1 : 0] || '';

            prod.stars_percent = product.AVERAGE_RATING
              ? Math.round((product.AVERAGE_RATING / 5) * 100)
              : 0;

            prod.atbLabel = self.translations.add_to_bag;
            prod.message_hidden = 'hidden';

            invStatus = parseInt(prod.defaultSku?.INVENTORY_STATUS, 10);

            if (invStatus === 7) {
              prod.message = self.translations.item_is_sold_out;
              prod.atbStatus = 'outofstock';
              prod.atbLabel = self.backOrderEnabled
                ? self.translations.sold_out
                : self.translations.item_is_sold_out;
              prod.message_hidden = '';
            } else if (invStatus === 2) {
              prod.message = self.translations.item_is_temp_out_of_stock;
              prod.atbStatus = self.backOrderEnabled ? '' : 'outofstock';
              prod.atbLabel = self.translations.temp_out_of_stock;
              prod.message_hidden = '';
            }
          });
        }
      } else if (Boolean(data) && Boolean(data.products) && data.products.length > 0) {
        data.products.forEach(function (val, i) {
          if (Boolean(val) && val.skus.length > 0) {
            data.products[i].first_medium_image =
            Boolean(val.skus[0].MEDIUM_IMAGE) && val.skus[0].MEDIUM_IMAGE.length > 0
              ? val.skus[0].MEDIUM_IMAGE[0]
              : '';
            data.products[i].stars_percent = Math.round(
              (data.products[i].AVERAGE_RATING / 5) * 100
            );
          }
        });
      }

      return data;
    },
    getLabelLength: function (product) {
      var self = this;
      var skus = product.skus || [];

      product.singleSize = skus.some(
        (sku) => sku?.PRODUCT_SIZE && sku.PRODUCT_SIZE.length > self.sizesMaxLength
      );
    },
    isCarousel: function ($skus, $sku) {
      var isShade = $skus.hasClass('sku-shades');
      var singleSize = $skus.attr('data-single-size') === 'true';
      var threshold;

      if (singleSize) {
        return true;
      }

      threshold = isShade ? 5 : 2;

      return $sku.length > threshold;
    },
    setAtbListener: function () {
      var self = this;
      var payload = {
        quantity: 1,
        replenishment: false
      };
      var $addtoBag = $('.js-modernized-product-brief-atb', $(self.selectors.carousel, self.nodes.$wrapper));
      var $addAlltoBag = $('.js-add-all-to-bag', $(self.nodes.$wrapper));
      var addedToBagText = $addAlltoBag.attr('data-added-to-bag') || 'Added to Bag';
      var addAllToBagText = $addAlltoBag.attr('data-add-all-to-bag') || 'Add all to Bag';

      // Handle "Add All to Bag" click
      function normalizeItem(item) {
        var prodData = {};
        var skuData = {};
        var key;

        for (key in item) {
          if (Object.prototype.hasOwnProperty.call(item, key)) {
            if (key.startsWith('prod.')) {
              prodData[key.substring(5)] = item[key];
            } else if (key.startsWith('sku.')) {
              skuData[key.substring(4)] = item[key];
            }
          }
        }

        item.product = prodData;
        item.product.sku = skuData;

        return item;
      }

      const onSuccess = function (rawResults) {
        var resultObj = rawResults.getData();
        var cartItems = [];
        var cartSkus = [];
        var item_count = rawResults?.getCartResults()?.getCount();
        var cartTemplate = $('script.inline-template[path="cart_confirm"]').html();
        var html;
        var $content;

        $('.js-page-utilities__cart-count').html(item_count);

        $.each(resultObj.ac_results, function (_, item) {
          if (item?.result?.CARTITEM && item?.result?.METHOD === 'addSku') {
            cartItems.push(normalizeItem(item.result.CARTITEM));
            if (item.result?.CARTITEM?.['sku.SKU_BASE_ID']) {
              cartSkus.push(item.result?.CARTITEM?.['sku.SKU_BASE_ID']);
            }
          }
        });

        html = cartItems
          .map(function (item) {
            return '<div class="cart-confirm__item">' + Mustache.render(cartTemplate, item) + '</div>';
          })
          .join('');

        if (html.length > 0) {
          $content = $('.js-cart-confirm__content');
          $content.html(html).parent().fadeIn(200);
          $content.find('.cart-confirm__shade-button').not(':last').remove();
        }

        $(document).trigger('cart_confirm_fade_in');

        setTimeout(function () {
          $('.js-cart-confirm__content').parent().fadeOut(200);
          $(document).trigger('cart_confirm_fade_out');
        }, 3500);

        if (typeof site?.track?.cartOverlay === "function") {
          site.track.cartOverlay();
        }

        $('.add-all-to-bag-progress', $(self.nodes.$wrapper))
          .text(addAllToBagText)
          .removeClass('add-all-to-bag-progress');

        $(window).trigger('addToCart.success', resultObj);

        if (Array.isArray(cartSkus) && cartSkus.length > 0) {
          self.openCart(cartSkus);
        }
      };
      const onFailure = function (rawResults) {
        var errorObjectsArray = '';

        $('.add-all-to-bag-progress', $(self.nodes.$wrapper))
          .text(addAllToBagText)
          .removeClass('add-all-to-bag-progress');

        errorObjectsArray = rawResults.getMessages();

        if ($('[data-controller="cart-drawer"]').length) {
          $(window).trigger('addToCart.failure', [errorObjectsArray]);
        } else {
          $(document).trigger('addToCart.failure', [errorObjectsArray]);
        }
      };

      if ($addAlltoBag.length > 0) {
        $addAlltoBag.once().on('click', function () {
          var $btn = $(this);
          var baseIds = $addtoBag
            .map(function (_, el) {
              const $el = $(el);
              if (!$el.hasClass('outofstock')) {
                return Number($el.attr('data-sku-base-id') || 0);
              }
              return null;
            })
            .get()
            .filter(Boolean);

          if (baseIds.length > 0) {
            $btn.addClass('add-all-to-bag-progress').text(addedToBagText);

            const args = {
              skus: [baseIds],
              QTY: 1,
              INCREMENT: 1,
              itemType: 'cart',
              quantity: 1,
              skuBaseId: baseIds
            };

            generic.checkout.cart.updateCart({
              params: args,
              onSuccess,
              onFailure
            });
          }
        });
      }

      // Handle individual Add to Bag clicks
      if ($addtoBag.length > 0) {
        $addtoBag.once().on('click', function () {
          var $btn = $(this);
          var baseId = $btn.attr('data-sku-base-id');
          var requestType = $btn.attr('data-request-type');
          var isNotifyMe = $btn.hasClass('js-quiz-notify-me');
          var overlayTemplate;

          if (baseId && isNotifyMe) {
            overlayTemplate = $('script.inline-template[path="waitlist_overlay"]').html();
            site.waitlistOverlay.launch(overlayTemplate, baseId, document, requestType);
          }

          if (baseId && !isNotifyMe) {
            $btn.addClass('add-to-bag-progress').text(addedToBagText);
            $(document).trigger('perlgem.cart.addItem', [baseId, payload]);
          }
        });
      }

      // Reset button states on cart success/failure
      $(document).on('addToCart.success addToCart.failure', function (e, data) {
        const item = data?.getItem?.();
        const baseId = item?.product?.sku?.SKU_BASE_ID;

        // Reset individual buttons
        $('.add-to-bag-progress', $(self.nodes.$wrapper))
          .text(self.translations.add_to_bag)
          .removeClass('add-to-bag-progress');

        if (baseId) {
          self.openCart([baseId]);
        }
      });
    },
    openCart: function (cartSkus) {
      if (window?.parentIFrame?.sendMessage instanceof Function && cartSkus?.length) {
        const atbDetail = {
          cartMode: 'modal',
          skuId: cartSkus,
          quantity: cartSkus.length
        };

        // Dispatch locally
        window.dispatchEvent(new CustomEvent('openCart', { detail: atbDetail }));

        // Try to dispatch to parent safely
        try {
          if (window.parent && window.parent !== window) {
            window.parent.dispatchEvent(
              new CustomEvent('openCart', { detail: atbDetail })
            );
          }
        } catch (err) {
          console.error('Error dispatching to parent:', err);
        }
      }
    },
    getWaitlistInventoryStatus: function (invStatus) {
      var self = this;
      var statusMap = {
        2: 'Temporarily out of stock',
        3: 'Coming Soon'
      };
      var statusKey = statusMap[invStatus];
      var $carousel = $(self.selectors.carousel, self.nodes.$wrapper);
      var $grid = $carousel.closest('.js-product-grid');
      var isNotifyMe = Number($grid.attr('data-notify-me')) === 1;
      var waitlist = false;

      // Check if waitlisting is enabled and the status is one of the configured statuses
      waitlist = Boolean(
        self.notifyMeEnabled &&
        Array.isArray(self.notifyMeEnabledByStatus) &&
        self.notifyMeEnabledByStatus.length > 0 &&
        statusKey &&
        isNotifyMe &&
        self.notifyMeEnabledByStatus.includes(statusKey)
      );

      return waitlist;
    },
    onSkuClick: function ($selectedSku) {
      var self = this;
      var invStatus = parseInt($selectedSku.attr('data-inventory-status-name'), 10);
      var nodes = $selectedSku.nodes;
      var baseHref;
      var separator;
      var deepLink;
      var $grid = $selectedSku.closest('.js-product-grid');
      var isPpu = Number($grid.attr('data-ppu')) === 1;
      var formattedUnitPrice = $selectedSku.attr('data-sku-formatted-unit-price');

      // Update active state and images
      nodes.siblings.removeClass('active');
      $selectedSku.addClass('active');
      nodes.media.eq(0).attr('src', $selectedSku.attr('data-sku-media'));
      nodes.media.eq(1).attr('src', $selectedSku.attr('data-sku-media-alt'));
      nodes.message.addClass('hidden');
      nodes.skuAtb.attr('data-sku-base-id', $selectedSku.attr('data-sku-id'));
      nodes.skuAtb.removeClass('js-quiz-notify-me');
      nodes.skuAtb.attr('data-request-type', '');

      // Handle inventory status
      if (invStatus === 1) {
        nodes.skuAtb.removeClass('outofstock').html(self.translations.add_to_bag);
        nodes.message.html('');
      } else if (invStatus === 2) {
        nodes.skuAtb
          .removeClass('outofstock')
          .html(self.translations.temp_out_of_stock);
        nodes.message
          .html(self.translations.item_is_temp_out_of_stock)
          .removeClass('hidden');
        if (!self.backOrderEnabled) {
          nodes.skuAtb.addClass('outofstock');
        }
        if (self.getWaitlistInventoryStatus(invStatus)) {
          nodes.skuAtb
            .addClass('js-quiz-notify-me')
            .attr('data-request-type', 'BIS')
            .removeClass('outofstock')
            .html(self.translations.notify_me);
        }
      } else if (invStatus === 3) {
        nodes.skuAtb
          .addClass('outofstock')
          .html(self.translations.coming_soon);
        nodes.message
          .html(self.translations.coming_soon_msg)
          .removeClass('hidden');
        if (self.getWaitlistInventoryStatus(invStatus)) {
          nodes.skuAtb
            .addClass('js-quiz-notify-me')
            .attr('data-request-type', 'CS')
            .removeClass('outofstock')
            .html(self.translations.notify_me);
        }
      } else if (invStatus === 7) {
        nodes.skuAtb
          .addClass('outofstock')
          .html(self.backOrderEnabled
            ? self.translations.sold_out
            : self.translations.item_is_sold_out);
        nodes.message
          .html(self.translations.item_is_sold_out)
          .removeClass('hidden');
      }

      // Update name and pricing
      nodes.name.html($selectedSku.attr('skuName'));
      nodes.priceContainer.removeClass('discounted');
      nodes.price.html($selectedSku.attr('data-sku-formatted-price'));
      nodes.price2.html($selectedSku.attr('data-sku-formatted-price2'));

      nodes.unitPrice.addClass('hidden');
      if (isPpu && formattedUnitPrice) {
        nodes.unitPrice.removeClass('hidden').html(formattedUnitPrice);
      }

      // Deep link with query param handling
      if (nodes.deepLink.attr('data-href')) {
        baseHref = nodes.deepLink.attr('data-href');
        separator = baseHref.includes('?') ? '&' : '?';
        deepLink = baseHref + separator + 'size=' + $selectedSku.attr('data-product-size');

        nodes.deepLink.attr('href', deepLink);
      }

      if ($selectedSku.attr('data-sku-price2')) {
        nodes.priceContainer.addClass('discounted');
      }
    },
    assignSkuNodes: function ($currentSku) {
      var $parent = $currentSku.closest('.js-modernized-product-brief');

      // Attach commonly used DOM nodes to the SKU element for reuse
      $currentSku.nodes = {
        parent: $parent,
        media: $parent.find('.js-modernized-product-brief-media img'),
        skuAtb: $parent.find('.js-modernized-product-brief-atb'),
        priceContainer: $parent.find('.js-modernized-product-brief-price'),
        price: $parent.find('.js-original-price'),
        price2: $parent.find('.js-discount-price'),
        unitPrice: $parent.find('.js-unit-price'),
        name: $parent.find('.js-modernized-product-brief-skuname'),
        siblings: $parent.find('.js-modernized-product-brief-sku'),
        message: $parent.find('.js-modernized-product-brief-unavailable'),
        deepLink: $parent.find('.js-product-deep-link')
      };
    },
    getInventoryStatus: function (sku) {
      var statusMap = {
        1: 'active',
        2: 'outOfStock',
        3: 'comingSoon',
        7: 'soldOut'
      };
      var statusKey = statusMap[sku.INVENTORY_STATUS];

      return {
        active: statusKey === 'active',
        outOfStock: statusKey === 'outOfStock',
        comingSoon: statusKey === 'comingSoon',
        soldOut: statusKey === 'soldOut'
      };
    },
    skuClickInit: function ($skus) {
      var self = this;

      $skus.find('.js-modernized-product-brief-sku').each(function () {
        var $sku = $(this);

        self.assignSkuNodes($sku);
        $sku.off('click').once().on('click', function () {
          self.onSkuClick($sku);
        });
      });
    },
    equalizeTitleHeights: function() {
      var self = this;

      // Target all product title headers inside the carousel
      const $titles = $('.js-product-modernized-header', $(self.selectors.carousel, self.nodes.$wrapper));
      var maxHeight = 0;

      if (!$titles.length) {
        return; // Exit early if nothing found
      }

      // Reset any previously set height
      $titles.css('min-height', 'auto');

      // Calculate max height
      $titles.each(function () {
        const height = Math.ceil($(this).outerHeight());
        if (height > maxHeight) maxHeight = height;
      });

      // Apply consistent min-height to all titles
      $titles.css('min-height', maxHeight + 'px');
    },
    generateCarousel: function () {
      var self = this;
      var $carouselSkus = $('.js-modernized-product-brief-skus', $(self.selectors.carousel, self.nodes.$wrapper));

      $carouselSkus.each(function () {
        var $skus = $(this);
        var defaultSkuId = $skus.attr('data-default-sku');
        var $skuItems = $skus.find('.js-modernized-product-brief-sku');
        var isSingleSize = $skus.attr('data-single-size') === 'true';
        var slideShowScroll = isSingleSize ? 1 : $skus.hasClass('sku-sizes') ? self.sizesToShow : self.shadesToShow;

        if (self.isCarousel($skus, $skuItems)) {
          $skus.removeClass('no-carousel');

          $skus.on('init', function () {
            self.skuClickInit($skus);
          });

          $skus.slick({
            dots: false,
            arrows: true,
            infinite: false,
            variableWidth: isSingleSize,
            slidesToScroll: slideShowScroll,
            slidesToShow: slideShowScroll,
            rtl: site.direction.isRTL,
            prevArrow:
              '<button class="modernized-product-brief__skus-carousel-arrows slide-arrow slick-prev" aria-label="Previous" type="button"><svg class="icon icon--arrow-left" style="fill:#040a2b;"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow:
              '<button class="modernized-product-brief__skus-carousel-arrows slide-arrow slick-next" aria-label="Next" type="button"><svg class="icon icon--arrow-left" style="fill:#040a2b;"><use xlink:href="#arrow-right"></use></svg></button>'
          });
        } else {
          self.skuClickInit($skus);
        }

        if (defaultSkuId) {
          const $defaultSku = $skuItems.filter(`[data-sku-id="${defaultSkuId}"]`);

          if ($defaultSku.length) {
            $defaultSku.trigger('click');

            // Get slick index of the slide
            const defaultSkuCurrentIndex = $defaultSku.closest('.slick-slide').data('slick-index');

            // Check if slick is initialized before moving
            if (typeof defaultSkuCurrentIndex !== 'undefined' && $skus.hasClass('slick-initialized')) {
              $skus.slick('slickGoTo', defaultSkuCurrentIndex);
            }
          } else {
            $skuItems.eq(0).trigger('click');
          }
        } else {
          $skuItems.eq(0).trigger('click');
        }

      });
    },
    setModernizedCarousel: function () {
      var self = this;
      var $carousel = $(self.selectors.carousel, self.nodes.$wrapper);
      var $grid = $carousel.closest('.js-product-grid');
      var slidesToShow = JSON.parse($grid.attr('data-grid-items-per-row') || '{}');
      var $arrowsDiv = $carousel.parent().find('.carousel-controls');
      var settings = {
        prevArrow: $arrowsDiv.find('.js-carousel-left-arrow'),
        nextArrow: $arrowsDiv.find('.js-carousel-right-arrow'),
        infinite: false,
        slidesToShow: slidesToShow.xlarge || 5,
        slidesToScroll: slidesToShow.xlarge || 5,
        rtl: site.direction.isRTL,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: slidesToShow.large,
              slidesToScroll: slidesToShow.large
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: slidesToShow.medium,
              slidesToScroll: slidesToShow.medium
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.12,
              slidesToScroll: 1
            }
          }
        ],
        onInit: function (_slick) {
          var $list = _slick.$list;

          $list
            .on(
              'touchstart.customSlick',
              _.debounce(function () {
                $list.addClass('swiping');
              }, 100)
            )
            .on(
              'touchend.customSlick touchcancel.customSlick',
              _.debounce(function () {
                $list.removeClass('swiping');
              }, 100)
            );
        }
      };

      $carousel.slick(settings);
    },

    setCarousel: function () {
      var self = this;
      var $carousel = $(self.selectors.carousel, self.nodes.$wrapper);
      var $arrowsDiv = $carousel.parent().find('.carousel-controls');
      var slidesToShow = JSON.parse(
        $carousel.closest('.js-product-grid').attr('data-grid-items-per-row')
      );
      var settings = {
        appendArrows: $arrowsDiv,
        infinite: true,
        slidesToShow: slidesToShow.large,
        slidesToScroll: slidesToShow.large,
        rtl: site.direction.isRTL,
        responsive: [
          {
            breakpoint: 1025,
            settings: 'unslick'
          }
        ],
        onInit: function (_slick) {
          _slick.$list
            .on(
              'touchend.customSlick touchcancel.customSlick',
              _.debounce(function () {
                $(this).removeClass('swiping');
              }, 100)
            )
            .on(
              'touchstart.customSlick',
              _.debounce(function () {
                $(this).addClass('swiping');
              }, 100)
            );
        }
      };

      // Init this carousel with our settings
      $carousel.slick(settings);
    },

    qsInit: function (context) {
      var $products = $('.js-product-brief', context);
      var productsArray = page_data['custom-mpp'].products || [];

      $products.each(function () {
        var $product = $(this);
        var productId = $product.data('product-id');
        var productData = _.find(productsArray, function (p) {
          if (!!p && !!p.PRODUCT_ID) {
            return p.PRODUCT_ID === productId;
          }
        });

        if (!!productData) {
          if (typeof site.product !== 'undefined' && typeof site.product.view !== 'undefined') {
            if (typeof site.product.view.equalRowHeight !== 'undefined') {
              site.product.view.equalRowHeight($product);
            }
            if (typeof site.product.view.brief !== 'undefined') {
              site.product.view.brief({
                containerNode: this,
                productData: productData
              });
            }
          }

          $('.qs_link', $product)
            .off()
            .on('click', function (event) {
              event.preventDefault();
              site.quickshop(productData);
            });
        }
      });
    },

    appendNodeContent: function () {
      var self = this;

      self.nodes.$contentApiWrapper = $(self.selectors.contentApiWrapper, self.nodes.$wrapper);
      self.attachedLibraries = [];
      var isMobile = parseInt(Unison.fetch.now().width) === parseInt(Unison.fetch.all().small);
      var deviceValue = isMobile ? 'mobile' : 'desktop';
      var apiConfig = {
        key: '0709040f8da71ca45eceb1ab8f2d8c5a',
        format: 'json',
        field: '+rendered,+attached',
        revision_tag: $.cookie('ELC_SITE_TAG') || '',
        locale: $.cookie('LOCALE') || 'en_US',
        device: deviceValue
      };

      if (typeof site.elcContentApi !== 'object') {
        return;
      }
      self.nodes.$contentApiWrapper.each(function () {
        var $this = $(this);
        var nodeId = $this.data('contentFor');

        apiConfig.node = nodeId;
        var getData = site.elcContentApi.getData(apiConfig, true);

        getData.then(function (responseData) {
          $this.html(responseData.rendered);
          Drupal.attachBehaviors(self.nodes.$contentApiWrapper);
        });
      });
    }
  };
})(jQuery, site || {});
